/**
 * @file 登录令牌存取工具
 * @description 统一封装 sessionStorage 与 Cookie 中的登录 token 读取、写入和清理。
 */
import Cookies from 'js-cookie'

/** 登录令牌存储键 */
const TOKEN_KEY = 'tdm-token'

/**
 * 获取存储的 token
 * @returns 当前登录 token；不存在时返回空字符串。
 */
export function getToken(): string {
  return sessionStorage.getItem(TOKEN_KEY) || Cookies.get(TOKEN_KEY) || ''
}

/**
 * 设置 token
 * @param token - token 字符串
 * @param rememberMe - 是否持久化到 cookie
 */
export function setToken(token: string, rememberMe = false): void {
  if (rememberMe) {
    Cookies.set(TOKEN_KEY, token, { expires: 14 }) // 14天过期
  } else {
    sessionStorage.setItem(TOKEN_KEY, token)
  }
}

/**
 * 移除 token
 * @returns 无返回值。
 */
export function removeToken(): void {
  sessionStorage.removeItem(TOKEN_KEY)
  Cookies.remove(TOKEN_KEY)
}
